import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import SnackbarContent from '@material-ui/core/SnackbarContent';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function NetworkError({ error, setError }) {
  const classes = useStyles();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={!!error}
      autoHideDuration={5000}
      onClose={() => setError(false)}
    >
      <SnackbarContent
        className={classes.error}
        ContentProps={{
          'aria-describedby': 'network-error',
        }}
        message={
          <span id="network-error" className={classes.message}>
            <ErrorIcon className={classes.iconVariant} />
            Error applying your changes: <br />
            {error && error.toString()}
          </span>
        }
        action={[
          <IconButton key="close" aria-label="close" color="inherit" onClick={() => setError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}
